import { Routes } from '@angular/router';
import { authGuard, loginGuard } from './core/guards/auth.guard';
import { adminAccessGuard } from './core/guards/admin-access.guard';
import { sigmaAccessGuard } from './core/guards/sigma-access.guard';
import { grafanaOnPremAccessGuard } from './core/guards/grafana-on-prem-access.guard';
import { navigatorAccessGuard } from './core/guards/navigator-access.guard';
import { settingsAdminAccessGuard } from './core/guards/settings-admin-access.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/settings/default-redirect.component').then(m => m.DefaultRedirectComponent)
  },
  {
    path: 'auth',
    canActivate: [loginGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'dig-deeper',
    loadComponent: () => import('./features/auth/dig-deeper/dig-deeper.component').then(m => m.DigDeeperComponent)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      // Routes for features not yet exposed in navigation — uncomment when ready
      // {
      //   path: 'automation',
      //   loadComponent: () => import('./features/automation/automation').then(m => m.Automation)
      // },
      // {
      //   path: 'search',
      //   loadComponent: () => import('./features/search/search-results/search-results.component').then(m => m.SearchResultsComponent)
      // },
      // {
      //   path: 'support-center',
      //   loadComponent: () => import('./features/support-center/support-center.component').then(m => m.SupportCenterComponent)
      // },
      {
        path: 'sigma-dashboard',
        redirectTo: 'sigma-dashboard/recents',
        pathMatch: 'full'
      },
      {
        path: 'sigma-dashboard/recents',
        canActivate: [sigmaAccessGuard],
        loadComponent: () => import('./features/analytics/sigma-dashboard/sigma-dashboard.component').then(m => m.SigmaDashboardComponent)
      },
      {
        path: 'sigma-dashboard/folders',
        canActivate: [sigmaAccessGuard],
        loadComponent: () => import('./features/analytics/sigma-dashboard/sigma-dashboard.component').then(m => m.SigmaDashboardComponent)
      },
      {
        path: 'sigma-dashboard/favorites',
        canActivate: [sigmaAccessGuard],
        loadComponent: () => import('./features/analytics/sigma-dashboard/sigma-dashboard.component').then(m => m.SigmaDashboardComponent)
      },
      {
        path: 'sigma-dashboard/all',
        canActivate: [sigmaAccessGuard],
        loadComponent: () => import('./features/analytics/sigma-dashboard/sigma-dashboard.component').then(m => m.SigmaDashboardComponent)
      },
      {
        path: 'sigma-dashboard/:workbookUrlId',
        canActivate: [sigmaAccessGuard],
        loadComponent: () => import('./features/analytics/sigma-dashboard/sigma-dashboard.component').then(m => m.SigmaDashboardComponent)
      },
      {
        path: 'grafana-on-prem-dashboard',
        redirectTo: 'grafana-on-prem-dashboard/all',
        pathMatch: 'full'
      },
      {
        path: 'grafana-on-prem-dashboard/folders',
        canActivate: [grafanaOnPremAccessGuard],
        loadComponent: () => import('./features/analytics/grafana-on-prem-dashboard/grafana-on-prem-dashboard.component').then(m => m.GrafanaOnPremDashboardComponent)
      },
      {
        path: 'grafana-on-prem-dashboard/all',
        canActivate: [grafanaOnPremAccessGuard],
        loadComponent: () => import('./features/analytics/grafana-on-prem-dashboard/grafana-on-prem-dashboard.component').then(m => m.GrafanaOnPremDashboardComponent)
      },
      {
        path: 'grafana-on-prem-dashboard/:dashboardUid',
        canActivate: [grafanaOnPremAccessGuard],
        loadComponent: () => import('./features/analytics/grafana-on-prem-dashboard/grafana-on-prem-dashboard.component').then(m => m.GrafanaOnPremDashboardComponent)
      },
      {
        path: 'grafana-cloud-dashboard',
        redirectTo: 'grafana-cloud-dashboard/all',
        pathMatch: 'full'
      },
      {
        path: 'grafana-cloud-dashboard/folders',
        canActivate: [adminAccessGuard],
        loadComponent: () => import('./features/analytics/grafana-cloud-dashboard/grafana-cloud-dashboard.component').then(m => m.GrafanaCloudDashboardComponent)
      },
      {
        path: 'grafana-cloud-dashboard/all',
        canActivate: [adminAccessGuard],
        loadComponent: () => import('./features/analytics/grafana-cloud-dashboard/grafana-cloud-dashboard.component').then(m => m.GrafanaCloudDashboardComponent)
      },
      {
        path: 'grafana-cloud-dashboard/:dashboardUid',
        canActivate: [adminAccessGuard],
        loadComponent: () => import('./features/analytics/grafana-cloud-dashboard/grafana-cloud-dashboard.component').then(m => m.GrafanaCloudDashboardComponent)
      },
      // {
      //   path: 'users',
      //   loadComponent: () => import('./features/placeholder/placeholder.component').then(m => m.PlaceholderComponent),
      //   data: { title: 'Users' }
      // },
      {
        path: 'admin-dashboard',
        canActivate: [adminAccessGuard],
        loadComponent: () => import('./features/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent),
        children: [
          { path: '', redirectTo: 'overview', pathMatch: 'full' },
          {
            path: 'overview',
            loadComponent: () => import('./features/admin-dashboard/tabs/admin-overview-tab.component').then(m => m.AdminOverviewTabComponent)
          },
          {
            path: 'performance',
            loadComponent: () => import('./features/admin-dashboard/tabs/admin-performance-tab.component').then(m => m.AdminPerformanceTabComponent)
          },
          {
            path: 'activity',
            loadComponent: () => import('./features/admin-dashboard/tabs/admin-activity-tab.component').then(m => m.AdminActivityTabComponent)
          },
          {
            path: 'errors-security',
            loadComponent: () => import('./features/admin-dashboard/tabs/admin-errors-security-tab.component').then(m => m.AdminErrorsSecurityTabComponent)
          },
          {
            path: 'health',
            loadComponent: () => import('./features/admin-dashboard/tabs/admin-health-tab.component').then(m => m.AdminHealthTabComponent)
          }
        ]
      },
      {
        path: 'canary-backfill',
        canActivate: [adminAccessGuard],
        loadComponent: () => import('./features/canary-backfill/canary-backfill.component').then(m => m.CanaryBackfillComponent),
        children: [
          { path: '', redirectTo: 'active', pathMatch: 'full' },
          {
            path: 'active',
            loadComponent: () => import('./features/canary-backfill/tabs/canary-active-jobs-tab.component').then(m => m.CanaryActiveJobsTabComponent)
          },
          {
            path: 'history',
            loadComponent: () => import('./features/canary-backfill/tabs/canary-history-tab.component').then(m => m.CanaryHistoryTabComponent)
          }
        ]
      },
      {
        path: 'settings',
        loadComponent: () => import('./features/settings/settings.component').then(m => m.SettingsComponent),
        children: [
          { path: '', redirectTo: 'general', pathMatch: 'full' },
          {
            path: 'general',
            loadComponent: () => import('./features/settings/components/settings-general/settings-general.component').then(m => m.SettingsGeneralComponent)
          },
          {
            path: 'admin',
            canActivate: [settingsAdminAccessGuard],
            loadComponent: () => import('./features/settings/components/settings-admin/settings-admin.component').then(m => m.SettingsAdminComponent)
          }
        ]
      },
      {
        path: 'ella',
        loadChildren: () => import('./features/ella/ella.routes').then(m => m.ELLA_ROUTES)
      },
      {
        path: 'scarlett',
        loadChildren: () => import('./features/scarlett/scarlett.routes').then(m => m.SCARLETT_ROUTES)
      },
      {
        path: 'navigator',
        canActivate: [navigatorAccessGuard],
        loadComponent: () => import('./features/navigator/navigator.component').then(m => m.NavigatorComponent)
      },
      {
        path: 'evo-edge',
        canActivate: [adminAccessGuard],
        loadComponent: () => import('./features/evo-edge/evo-edge.component').then(m => m.EvoEdgeComponent)
      },
      {
        path: 'asset-trends',
        loadChildren: () => import('./features/asset-trends/asset-trends.routes').then(m => m.ASSET_TRENDS_ROUTES)
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./features/settings/default-redirect.component').then(m => m.DefaultRedirectComponent)
  }
];
